import { render, staticRenderFns } from "./TlmImg.vue?vue&type=template&id=64d22787"
import script from "./TlmImg.vue?vue&type=script&lang=js"
export * from "./TlmImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FallbackImage: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/FallbackImage.vue').default})
